module.exports = __webpack_public_path__ + "static/media/Curoflow telemedicine platform in Sweden.4cf21de8.webp";